import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { orderBy, process, State, SortDescriptor } from '@progress/kendo-data-query';
import { Info } from '../../../../../core/common';
import { IPromoCode } from '../../../../../core/models';
import { AdminService } from '../../../../../core/services/admin.service';
import { Subject } from 'rxjs';
import { AppNotifyService } from '../../../../../core/services/app-notify.service';
import { NotifyType } from 'src/app/core/enums/NotifyType';

@Component({
  selector: 'app-promo-code',
  templateUrl: './promo-code.component.html',
  styleUrls: ['./promo-code.component.scss']
})
export class PromoCodeComponent implements OnInit {
  //#region member variable
  promoCodeGridView: GridDataResult;
  promoCodeLoading: boolean;

  promoCodeForm: FormGroup;
  saveInProcess: boolean;
  public infoMessage: Info = new Info();
  public inProgressMessage: boolean;
  public successMessage: boolean;
  public errorMessage: boolean;

  //#endregion
  constructor(private formBuilder: FormBuilder, private adminService: AdminService,
    private appNotifyService: AppNotifyService,

  ) { }

  ngOnInit() {
    this.loadPromoCodeGrid();
    this.promoCodeForm = this.formBuilder.group({
      promoCodeId: new FormControl(""),
      promoCode: new FormControl(""),
      promoCodeDescription: new FormControl(""),
      startDate: new FormControl(""),
      endDate: new FormControl(""),
      minPrice: new FormControl(""),
      maxPrice: new FormControl(""),
      productType: new FormControl(""),
      region: new FormControl(""),
      terittory: new FormControl(""),
      customer: new FormControl(""),
      isActive: new FormControl(false)
    })
  }
  //#region Grid data binding
  private loadPromoCodeGrid(): void {
    this.promoCodeLoading = true;
    this.adminService.getPromoCode().subscribe((response) => {
      this.bindPromoCodeGrid();
      this.promoCodeLoading = false;
    });
  }
  //#endregion

  //#region label and variable declaration
  promoCodes = {
    promoCodeLbl: "Promo Code",
    promoCodeDescriptionLbl: "Promo Code Description",
    startDateLbl: "Start Date",
    endDateLbl: "End Date",
    minPriceLbl: "Min Price",
    maxPriceLbl: "Max Price",
    productTypeLbl: "Product Type",
    regionLbl: "Region",
    TerritoryLbl: "Territory",
    CustomerLbl: "Customer",
    isActiveLbl: "IsActive",
    actionLbl: "Action",
    isEmptyPromoCode: false,
    isEmptyPromoDescription: false,
    isEmptyStartDate: false,
    isEmptyEndDate: false,
    isSubmitted: false,
    todayDate: new Date(),
    isEndDateInValid:false
  }
  //#endregion
  //#region pagination, sorting,filtering for grid

  public promoCodeGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'promoCodeId',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };
  private bindPromoCodeGrid(): void {    
    const data = this.adminService.promoCodes;
    this.promoCodeGridView = process(data, this.promoCodeGridstate);
  }

  protected promoCodeGridSortChange(sort: SortDescriptor[]): void {
    this.promoCodeGridstate.sort = sort;
    this.bindPromoCodeGrid();
  }
  protected promoCodeGridPageChange({ skip, take }: PageChangeEvent): void {
    this.promoCodeGridstate.skip = skip;
    this.promoCodeGridstate.take = take;
    this.bindPromoCodeGrid();
  }

  public promoCodeDataStateChange(state: DataStateChangeEvent): void {
    this.promoCodeGridstate = state;
    this.bindPromoCodeGrid();
  }
  //#endregion

  //#region Promo code dialog operation

  promoCodeDialog = {
    opened: false,
  }
  togglePromoCodeDialog() {
    this.promoCodeDialog.opened = !this.promoCodeDialog.opened;
    if (this.promoCodeDialog.opened == false) {
      this.resetPromoCodeForm();
    } else {
      this.promoCodeForm.controls.isActive.setValue(true);
    }
  }

  editPromoCode(data: IPromoCode) {
    this.promoCodeDialog.opened = !this.promoCodeDialog.opened;
    this.promoCodeForm.controls.promoCodeId.setValue(data.promoCodeId);
    this.promoCodeForm.controls.promoCode.setValue(data.promoCode);
    this.promoCodeForm.controls.promoCodeDescription.setValue(data.promoCodeDescription);
    if (data.startDate) {
      let startDate = new Date(data.startDate);
      this.promoCodeForm.controls.startDate.setValue(startDate);
    }
    if (data.endDate) {
      let endDate = new Date(data.endDate);
      this.promoCodeForm.controls.endDate.setValue(endDate);
    }
    this.promoCodeForm.controls.minPrice.setValue(parseInt(data.minPrice));
    this.promoCodeForm.controls.maxPrice.setValue(parseInt(data.maxPrice));
    //add for remaining controls
    this.promoCodeForm.controls.isActive.setValue(data.isActive)
  }

  resetPromoCodeForm() {
    this.promoCodes.isSubmitted = false;
    this.promoCodeForm.reset();
    this.promoCodes.isEmptyPromoCode = false;
    this.promoCodes.isEmptyPromoDescription = false;
    this.promoCodes.isEmptyStartDate = false;
    this.promoCodes.isEmptyEndDate = false;
    this.promoCodes.isEndDateInValid = false;
    this.infoMessage = new Info();
    this.saveInProcess = false;
  }

  protected validatePromoCodeForm(): boolean {
    let isValid = true;
    const controls = this.promoCodeForm.controls;
    if (this.promoCodes.isSubmitted) {
      if (controls.promoCode.value) {
        this.promoCodes.isEmptyPromoCode = false;
      } else {
        this.promoCodes.isEmptyPromoCode = true;
        isValid = false;
      }
      if (controls.promoCodeDescription.value) {
        this.promoCodes.isEmptyPromoDescription = false;
      } else {
        this.promoCodes.isEmptyPromoDescription = true;
        isValid = false;
      }
      if (controls.startDate.value) {
        this.promoCodes.isEmptyStartDate = false;
      } else {
        this.promoCodes.isEmptyStartDate = true;
        isValid = false;
      }
      if (controls.endDate.value) {
        this.promoCodes.isEmptyEndDate = false;
      } else {
        this.promoCodes.isEmptyEndDate = true;
        isValid = false;
      }

    }
    return isValid;
  }

  public savePromoCode() {
    this.promoCodes.isSubmitted = true;
    if (!this.validatePromoCodeForm()) {
      return;
    }
    var controls = this.promoCodeForm.controls;
    //Checking end date validation here
    if (controls.startDate.value > controls.endDate.value) {
      this.promoCodes.isEmptyEndDate = true;
      this.promoCodes.isEndDateInValid = true;
      return;
    } else {
      this.promoCodes.isEndDateInValid = false;
    }
    this.inProgressMessage = true;
    this.infoMessage.genericSuccess = "";
    this.infoMessage.genericError = "";
    this.infoMessage.genericInProgress = this.infoMessage.inProgressMessage;
    this.saveInProcess = true;
    const body: IPromoCode = {
      promoCodeId: controls.promoCodeId.value,
      promoCode: controls.promoCode.value,
      promoCodeDescription: controls.promoCodeDescription.value,
      startDate: controls.startDate.value,
      endDate: controls.endDate.value,
      minPrice: controls.minPrice.value?controls.minPrice.value.toString():"",
      maxPrice: controls.maxPrice.value?controls.maxPrice.value.toString():"",
      //assign data below
      productType: "",
      region: "",
      terittory: "",
      customer: "",
      isActive: controls.isActive.value ? controls.isActive.value : false
    }
    this.adminService.savePromoCode(body).subscribe((response: any) => {
      this.infoMessage.genericInProgress = "";
      this.saveInProcess = false;
      if (response) {
        this.resetPromoCodeForm();
        this.successMessage = true;
        this.infoMessage.genericSuccess = this.infoMessage.successMessage;
        //this.bindPromoCodeGrid();//commenting this because date format is not correct in cache
        this.loadPromoCodeGrid();//Need to remove this method once date format issue resolve
      } else {
        this.infoMessage.genericError = this.infoMessage.errorMessage;
      }
    })
  }
  //#endregion
  //endregion


  //#region delete item
  public gridItemToRemove: any;
  public removeConfirmationSubject: Subject<boolean> = new Subject<boolean>();

  gridDelete = {
    label: {
      deleteConfirmLbl: 'Are you sure you want to delete promo code ',
      deleteYesLbl: 'Yes',
      deleteNoLbl: 'No',
      confirmLbl: 'Please confirm',
    }
  }


  public removeConfirmation(dataItem): Subject<boolean> {
    this.gridItemToRemove = dataItem; // show delete item confirmation box
    return this.removeConfirmationSubject;
  }

  protected confirmRemove(shouldRemove: boolean): void {
    if (shouldRemove) {
      this.removeConfirmationSubject.next(shouldRemove);
      this.RemoveHandler();
    }
    else {
      this.removeConfirmationSubject.next(shouldRemove);
      this.gridItemToRemove = null;
    }
  }
  protected RemoveHandler() {
    this.adminService.deletePromoCode(this.gridItemToRemove).subscribe((isRemoved: boolean) => {
      const promoCodeId = this.gridItemToRemove.promoCodeId;
      this.gridItemToRemove = null;
      this.appNotifyService.notify(NotifyType.SUCCESS, "Selected promo code has been removed.");

      if (this.adminService.promoCodes) {
        //This is a Local Remove
        const index = (this.adminService.promoCodes).findIndex(r => r.promoCodeId === promoCodeId);
        (this.adminService.promoCodes).splice(index, 1);
        this.bindPromoCodeGrid();

      }



    }, error => {
      this.appNotifyService.notify(NotifyType.ERROR, 'An Error Occured');
    });
  }

  //#endregion
}
